// neurotrader-admin/src/components/AdminSidebar.js

import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AdminSidebar.css'; // Reutiliza o mesmo CSS
import { FiHome, FiUsers, FiPackage, FiBarChart2, FiLogOut } from 'react-icons/fi'; // Ícones relevantes para admin
import logo from '../assets/logo.png'; // Garanta que a logo esteja na pasta assets

const AdminSidebar = () => {
    const { user, logout } = useAuth();

    return (
        <div className="sidebar">
            <div className="sidebar-content">
                <div className="sidebar-header">
                    <h1 className="sidebar-title">Admin</h1>
                    <img src={logo} alt="NeuroTrader Logo" className="sidebar-logo"/>
                </div>
                <nav className="sidebar-nav">
                    <NavLink to="/" className="sidebar-link" end>
                        <FiHome className="sidebar-icon" />
                        <span>Dashboard</span>
                    </NavLink>
                    <NavLink to="/clientes" className="sidebar-link">
                        <FiUsers className="sidebar-icon" />
                        <span>Clientes</span>
                    </NavLink>
                    <NavLink to="/pedidos" className="sidebar-link">
                        <FiPackage className="sidebar-icon" />
                        <span>Pedidos</span>
                    </NavLink>
                    <NavLink to="/bots" className="sidebar-link">
                        <FiBarChart2 className="sidebar-icon" />
                        <span>Estatísticas dos Bots</span>
                    </NavLink>
                </nav>
            </div>

            <div className="sidebar-footer">
                <div className="user-info-sidebar">
                    {/* Acessa o email da forma "plana" correta */}
                    <span className="user-email-sidebar">{user?.email}</span>
                </div>
                <button onClick={logout} className="logout-button-sidebar">
                    <FiLogOut className="logout-icon"/>
                    <span>Sair</span>
                </button>
            </div>
        </div>
    );
};

export default AdminSidebar;